import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=25c34950"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c34950')) {
      api.createRecord('25c34950', component.options)
    } else {
      api.reload('25c34950', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=25c34950", function () {
      api.rerender('25c34950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/subSidebar/Link.vue"
export default component.exports